import { FormControl, Validators } from '@angular/forms';
import { PaymentMethod } from '../models/payment-method.model';
import { PaymentMethodUtils } from '../utils/payment-method-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class PaymentMethodFormControl extends FormControl<PaymentMethod | string> {
  isBillGatewayApp$: Observable<boolean>;

  public constructor() {
    super(null, [Validators.required]);
    this.isBillGatewayApp$ = this.valueChanges.pipe(map(value => PaymentMethodUtils.isImojePaymentMethod(value)));
  }
}
